import once from 'lodash/once';
import Tracking from '@spotahome/soyuz-tracking';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { useEcommerceManagerFactory } from '@spotahome/ecommerce-tracking';

// `listId` (optional) overrides the GA4 item_list_id; defaults baked into
// the ecommerce layer keep classic search reporting as 'search'. The
// agentic surface passes 'agentic_search' so it shows up as its own list.
const useHomecardListTracking = (cityId, listId) => {
  const ecommerceManager = useEcommerceManagerFactory();
  const triggerHotjarPermanentBookingRecording = once(() => {
    Tracking.hotjar.triggerEvent('permanent_booking_search');
  });

  const trackProductImpressions = (cardList, indexedHomecards) => {
    try {
      const cardListWithoutSoldouts = cardList.filter(m => !m.so);
      const cardIds = cardListWithoutSoldouts.map(m => m.id.toString());
      const homecardsWithoutSoldouts = Object.fromEntries(
        Object.entries(indexedHomecards).filter(([id]) => cardIds.includes(id))
      );

      ecommerceManager.trackSearchPageImpressions(
        cardListWithoutSoldouts,
        homecardsWithoutSoldouts,
        cityId,
        listId
      );

      SoyuzAnalytics.sendGA4Event('show', {
        section: 'soldout-homecard-list',
        items: cardList
          .filter(m => m.so)
          .map(m => ({
            item_id: m.id
          }))
      });
    } catch (err) {
      console.error(err);
    }
  };

  const trackHomecardClick = (position, cardData) => {
    SoyuzAnalytics.sendGA4Event('homecard_click', {
      id: cardData.id,
      position,
      cityId,
      metric_id: 'isMultiListing',
      metric_value: cardData.totalCountMultilistings > 0,
      ...(listId ? { item_list_id: listId } : {})
    });
    ecommerceManager.trackSearchPageHomecardClick(
      cardData,
      position,
      cityId,
      listId
    );
  };

  const triggerHotjarRecording = (homecards = {}) => {
    const hasHomecardWithPermanentDuration = Object.values(homecards).find(
      homecard => homecard.allowsPermanentContract
    );

    if (hasHomecardWithPermanentDuration) {
      triggerHotjarPermanentBookingRecording();
    }
  };

  return {
    trackInitialMount: (markerList, homecards) => {
      trackProductImpressions(markerList, homecards);
      triggerHotjarRecording(homecards);
    },
    trackProductImpressions,
    trackHomecardClick,
    triggerHotjarRecording
  };
};

export default useHomecardListTracking;
